<template>
  <div class="tree-form-tree-container">
    <!-- TODO: need refine -->
    <div v-if="API.form.content">
    <!-- <div> -->
      <el-form label-width="150px" :model="formData" ref="form" label-position="right" :rules="rules">
        <el-form-item v-for="(item, index) of formData" :key="index" :label="item.label" v-if="item.hasValue === true" :rules="item.rules" :prop="'[' + index + '].value'" >
          <el-input v-model="formData[index].value" v-if="formData[index].type === 'string'"></el-input>
          <el-input-number v-model="formData[index].value" v-else-if="formData[index].type === 'number'" :min="formData[index].min" :max="formData[index].max"></el-input-number>
          <el-select v-model="formData[index].value" v-else-if="formData[index].type === 'select'" filterable>
            <el-option v-for="item of formData[index].options" :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-if="API.form.content" @click="saver">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getConstantsAttributeById } from '@/api/constants-controller'

export default {
  name: 'energyTypeForm',
  props: ['API'],
  data () {
    const checkName = (rules, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('名称不可为空，请输入'))
      } else {
        callback()
      }
    }
    const checkValue = (rules, value, callback) => {
      if (value === 0) {
        callback(new Error('该系数值不可为0'))
      } else {
        callback()
      }
    }
    return {
      treeName: [],
      formData: {
        energyType: {
          label: '统计项种类',
          value: '',
          type: 'select',
          hasValue: false,
          options: [],
          rules: [
            { required: true, message: '统计项种类不能为空', trigger: 'change' }
          ]
        },
        energyName: {
          label: '名称',
          value: '',
          type: 'string',
          rules: [
            { required: true, message: '请输入统计项名称', trigger: 'blur' },
            { max: 25, message: '长度不可超过25个字符', trigger: 'blur' },
            { validator: checkName, trigger: 'blur' }
          ],
          hasValue: false
        },
        unit: {
          label: '显示单位',
          value: '',
          type: 'string',
          hasValue: false,
          rules: [
            { required: true, message: '显示单位不能为空', trigger: 'blur' },
            { validator: checkName, trigger: 'blur' }
          ]
        },
        coalRatio: {
          label: '折标准煤系数',
          value: 0,
          type: 'number',
          hasValue: false,
          min: 0,
          rules: [
            { required: true, message: '折标准煤系数不能为空', trigger: 'blur' },
            { validator: checkValue, trigger: 'blur' }
          ]
        },
        carbonRatio: {
          label: '碳排放系数',
          value: '',
          type: 'number',
          hasValue: false,
          min: 0,
          rules: [
            { required: true, message: '碳排放系数不能为空', trigger: 'blur' },
            { validator: checkValue, trigger: 'blur' }
          ]
        },
        usage: {
          label: '用途',
          value: '',
          type: 'string'
        },
        heatRatio: {
          label: '热值系数',
          value: '',
          type: 'number',
          hasValue: false
        },
        heatUnit: {
          label: '热值单位',
          value: '',
          type: 'string',
          hasValue: false
        }
      },
      vue: this,
      rules: {
        energyName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 3, max: 9, message: '长度在 3 到 9 个字符', trigger: 'blur' }]
      }
    }
  },
  methods: {
    saver () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formData.energyName.value = this.formData.energyName.value.trim()
          for (const item of this.API.treeData) {
            if (this.API.form.content.id) {
              if (this.API.form.content.id !== item.id && item.name === this.formData.energyName.value) {
                this.$message.error('统计项名称不可重复')
                return false
              }
              if (this.API.form.content.id !== item.id && item.energyType === this.formData.energyType.value) {
                this.$message.error('统计项种类不可重复')
                return false
              }
            } else {
              if (item.name === this.formData.energyName.value) {
                this.$message.error('统计项名称不可重复')
                return false
              }
              if (item.energyType === this.formData.energyType.value) {
                this.$message.error('统计项种类不可重复')
                return false
              }
            }
          }
          for (const [index, value] of Object.entries(this.formData)) {
            this.API.form.content[index] = value.value
          }
          this.API.form.content.label = this.formData.energyName.value
          const additionalInfo = JSON.parse(this.API.form.content.additionalInfo)
          for (const item in additionalInfo) {
            if (item !== 'energyPrice') {
              additionalInfo[item] = this.formData[item].value
            }
          }
          this.API.form.content.additionalInfo = additionalInfo
          console.log(this.API.form.content, '-----提交')
          this.API.handleFormSubmit(this.API, this)
        }
      })
    },
    getTreeName (data) {
      for (const item of data) {
        this.treeName.push({ id: item.id, name: item.name, energyType: item.energyType })
        if (item.children && item.children.length > 0) {
          this.getTreeName(item.children)
        }
      }
    }
  },
  created () {
    (async () => {
      const res = await getConstantsAttributeById({ type: 'energyType' })
      res.data.map(item => {
        const option = {
          label: item.value,
          value: item.key
        }
        this.formData.energyType.options.push(option)
      })
    })()
    for (const [index, value] of Object.entries(this.API.form.content)) {
      if (index !== 'additionalInfo' && this.formData[index]) {
        this.formData[index].value = value
        this.formData[index].hasValue = true
      }
      if (index === 'additionalInfo') {
        const info = JSON.parse(value)
        for (const item in info) {
          if (this.formData[item]) {
            this.formData[item].value = info[item]
            this.formData[item].hasValue = true
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-form-tree-container {
  max-height: 100%;
  flex: auto;
  padding: 0 20px;
  overflow-y: auto;
  h1 {
    margin-top: 0;
  }
  .form-container-with-table {
    padding-right: 5px;
    height: 50%;
    overflow-y: auto;
  }
}
</style>
